import { render, staticRenderFns } from "./CheckboxItemConfig.vue?vue&type=template&id=4665c185&scoped=true"
import script from "./CheckboxItemConfig.vue?vue&type=script&lang=js"
export * from "./CheckboxItemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4665c185",
  null
  
)

export default component.exports